// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarketAllocationFromJSON, MarketAllocationToJSON, } from './';
export function BlendedMarketDataFromJSON(json) {
    return {
        'allocations': !exists(json, 'allocations') ? undefined : json['allocations'].map(MarketAllocationFromJSON),
    };
}
export function BlendedMarketDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'allocations': value.allocations === undefined ? undefined : value.allocations.map(MarketAllocationToJSON),
    };
}
